import { isValidElement } from 'react';

export function getReactNodeText(node: React.ReactNode): string {
  if (typeof node === 'string') return node;
  if (Array.isArray(node)) return node.map(getReactNodeText).join(' ');
  if (isValidElement(node)) return getReactNodeText(node.props.children);
  return '';
}
